// ---------------------------------------------------------------------------
// Stub for re2js — deliberately does nothing.
//
// @firebase/firestore imports re2js at module scope, so webpack cannot tree
// shake it, and it lands in the bundle every visitor downloads: 158 KB raw,
// 47 KB gzipped, roughly a fifth of the initial JavaScript.
//
// Firestore only uses it to evaluate `like`, `regex_contains` and `regex_match`
// inside Pipelines — a query API Volcyy does not use. Every query in this
// codebase goes through where()/orderBy(). An npm `overrides` entry points the
// package here so those bytes are never shipped.
//
// If Firestore ever routes something else through re2js, compile() throws with
// this message rather than failing silently. That is the signal to remove the
// override in package.json and take the 47 KB back.
//
// Re-check this on every Firebase upgrade.
// ---------------------------------------------------------------------------

const MESSAGE =
  're2js is stubbed out in this build (see stubs/re2js). Firestore Pipelines ' +
  'regex operators are not supported. Remove the "overrides" entry in ' +
  'package.json if you need them.';

export class RE2JS {
  static compile() {
    throw new Error(MESSAGE);
  }
  static quote(s) {
    return String(s);
  }
}

export default { RE2JS };
